var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99976 8.30018C1.99976 8.68678 2.31316 9.00018 2.69976 9.00018H9.30008C9.68668 9.00018 10.0001 8.68678 10.0001 8.30018V6.00006V3.69994C10.0001 3.31334 9.68668 2.99994 9.30008 2.99994H5.99992H2.69976C2.31316 2.99994 1.99976 3.31334 1.99976 3.69994V6.00006V8.30018Z",
    fill: "#00C087",
    stroke: "#00C087",
    strokeWidth: 1.92008,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57666 3.64948L5.9741 6.26699L9.42329 3.64948",
    stroke: "white",
    strokeWidth: 0.960039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email-1.f94445f0fa55e006a10e235b47d76818.svg";
export { ForwardRef as ReactComponent };